import React from "react";
import api from "../@api";

class controllers extends React.Component {
  getTeamsList = (query) => {
    return new Promise((resolve, reject) => {
      api()
        .get("/teams/find", { params: query })
        .then((response) => {
          if (response.data.status === "success") {
            let data = response.data.result.Teams;
            resolve(data);
          }
          if (response.data.status === "failure") {
            reject("Something is wrong try later or contact the support");
          }
        })
        .catch((err) => {
          reject("Something is wrong try later or contact the support");
        });
    });
  };

  getTeamDetails = (teamId) => {
    return new Promise((resolve, reject) => {
      api()
        .get(`/teams/${teamId}`)
        .then((response) => {
          if (response.data.status === "success") {
            let data = response.data.team;
            resolve(data);
          }
          if (response.data.status === "failure") {
            reject("Something is wrong try later or contact the support");
          }
        })
        .catch((err) => {
          reject("Something is wrong try later or contact the support");
        });
    });
  };
}

const instance = new controllers();

export default instance;
